import React from "react";
import echarts from "echarts";
import util from "@util/index";

class Series extends React.Component {
  componentDidMount() {
    this.myChart = echarts.init(document.getElementById("pieCharts"));
    this.drawChart(this.props);
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
  }

  componentWillReceiveProps(nextProps) {
    this.drawChart(nextProps);
  }

  drawChart = params => {
    const { data } = params;
    this.myChart.setOption({
      title: {
        text: data.title,
      },
      tooltip: {
        trigger: "item",
        // formatter: '{a} <br/>{b} : {c} ({d}%)',
        formatter(obj) {
          return (
            `${obj.seriesName 
            }<br>${ 
            obj.name 
            }：${ 
            util.numberFormat(obj.value) 
            }(${ 
            obj.percent 
            }%)`
          );
        },
      },
      legend: {
        type: "scroll",
        orient: "vertical",
        right: 10,
        top: 20,
        bottom: 20,
        data: data.legendData,
        selected: data.selected,
      },
      series: [
        {
          name: "费用",
          type: "pie",
          radius: "55%",
          center: ["40%", "50%"],
          data: data.seriesData,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    });
    this.myChart.resize();
  };

  render() {
    return <div id="pieCharts" style={{ width: "100%", height: 500 }} />;
  }
}

export default Series;



// WEBPACK FOOTER //
// ./src/components/comm/charts/Pie2/Pie.js